(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'PackageRequest',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.confirmation = function confirmation(response)
	{
		Adzuki.Erez.ClientDuplicateEmail.confirm(response, form.name);
	};

	form.load = function load()
	{
		$('#packagerequest-sailing_category').change(function categoryChanged() {
			updatePricing($(this));
		});

		$('#packagerequest-number_pax').change(function numPaxChanged(e) {
			var pax_num = $(this).val();
			updatePricing($('#packagerequest-sailing_category'));

			 Adzuki.ClientNewOrExisting.toggleClientFields($('.package-request'), pax_num);
			 updateClients($('#package-include_clients'));
		});

		$('#package-include_clients').change( function dostuff(s) {
			updateClients($('#package-include_clients'));
		});
	};

	function updateClients(obj) {
		var checkbox            = $('input[id=packagerequest-include_clients]'),
			checkbox_val        = checkbox.prop('checked'),
			new_existing_client = $('#package-request').find('.new-existing-client'),
			pax_num             = $('#packagerequest-number_pax').val();

		if (checkbox_val === true) {
			$('input[type=checkbox]').val('1');
			Adzuki.ClientNewOrExisting.toggleClientFields($('.package-request'), pax_num);
		} else {
			$('input[type=checkbox]').val('0');
			new_existing_client.each(function hideClients(w) {
				$(this).addClass('hidden');
			});
		}
	}

	function updatePricing(obj) {
		var num_pax            = parseInt($('#packagerequest-number_pax').val()),
			selected_category  = obj.val(),
			deposit            = Number($('#packagerequest-deposit').val().replace(/[^0-9\.-]+/g, "")),
			final_payment_date = $('#packagerequest-final_payment_date').val(),
			category_parts,
			adv_12,
			adv_34,
			package_price,
			final_payment_amount,
			category_dropdown;

		if (num_pax > 0) {
			category_parts = selected_category.split("|");
			adv_12         = category_parts[1];
			adv_34         = category_parts[2];

			if (num_pax > 2) {
				if (adv_34 > 0) {
					package_price = adv_12 * 2;
				} else {
					package_price = adv_12 * num_pax;
				}
			} else {
				package_price = adv_12 * num_pax;
			}

			final_payment_amount = package_price - deposit;

			if (!isNaN(package_price)) {
				$('.package-price').html('<strong>' + accounting.formatMoney(package_price) + '</strong> <small>(includes NCF & gov\'t taxes)</small>');
				$('.final-payment-amount').html('<strong>' + accounting.formatMoney(final_payment_amount)+ '</strong> <small>(final payment due ' + final_payment_date + ' )</small>');

				$('#packagerequest-package_price').val(package_price);
				$('#packagerequest-final_payment_amount').val(final_payment_amount);

				category_dropdown = $('#packagerequest-sailing_category').find('option:selected');

				$('#packagerequest-sailing_category_name').val(category_dropdown.text());
			}
		}
	}

}(jQuery, window.Adzuki || {}));
